import {useIsDesktop} from '@eCommerce/frontend-legacy-shared-library-native';
import {View} from 'native-base';
import React from 'react';

import SecurityMask from 'components/SecurityMask';

const GatedCountry = () => {
  const isDesktop = useIsDesktop();

  return (
    <View mb={isDesktop ? '40px' : 4} width={isDesktop ? '100%' : '80%'}>
      <SecurityMask title="Country" showAsterisk />
    </View>
  );
};

export default GatedCountry;
